module.exports = __webpack_public_path__ + "media/img/decorations/our-work-right-00e82776aee12bfb1e997deefd6c7122.svg";